document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.nice-tab_title').forEach(tabTitle => {
    tabTitle.addEventListener('click', function() {
      const tabID = tabTitle.getAttribute('id');
      tabTitle.closest('.nice-tab__header').querySelector('.nice-tab_title.active').classList.remove('active');
      tabTitle.classList.add('active');
      tabTitle.closest('.nice-tab').querySelector('.nice-tab__content.active').classList.remove('active');
      tabTitle.closest('.nice-tab').querySelector(`.nice-tab__content[for="${tabID}"]`).classList.add('active'); 
      console.log(tabTitle.closest('.nice-tab').querySelector(`.nice-tab__content[for="${tabID}"]`));
      console.log(tabTitle.closest('.nice-tab').querySelector('.nice-tab__content.active'));
    });
  });
});